document.addEventListener('DOMContentLoaded',()=>{
  const parseMoney=(value)=>{
    const raw=String(value||'').replace(/,/g,'');
    const matches=raw.match(/\d+(?:\.\d+)?/g);
    if(!matches||!matches.length)return 0;
    const n=Number(matches[matches.length-1]);
    return Number.isFinite(n)?n:0;
  };
  const pctOff=(compare,price)=>compare>price&&compare>0?Math.max(1,Math.round(((compare-price)/compare)*100)):0;

  document.querySelectorAll('.pp-product-card').forEach(card=>{
    const partial=card.querySelector('a[href*="/products/partial-payment"]');
    if(partial){card.remove();return;}
    const sale=card.querySelector('[data-pp-card-sale]');
    if(!sale||card.querySelector('.pp-card-sale-line'))return;
    const info=card.querySelector(':scope > div');
    const price=info?info.querySelector(':scope > strong'):null;
    if(!price)return;
    const line=document.createElement('div');
    line.className='pp-card-sale-line';
    line.innerHTML=`<s>MRP ${sale.dataset.compare}</s><em>${sale.dataset.discount}% OFF</em>`;
    price.insertAdjacentElement('afterend',line);
  });

  const productPage=document.querySelector('[data-pp-product-page]');
  const priceRow=productPage?productPage.querySelector('.pp-product-price-row'):null;
  const priceEl=productPage?productPage.querySelector('[data-pp-price]'):null;
  const compareEl=productPage?productPage.querySelector('[data-pp-compare]'):null;
  const badge=productPage?productPage.querySelector('[data-pp-saving]'):null;
  let mrpLabel=null;
  let offerLabel=null;

  if(priceRow&&priceEl&&compareEl&&badge){
    priceRow.classList.add('pp-price-clarified');
    mrpLabel=document.createElement('span');
    mrpLabel.className='pp-price-mrp-label';
    mrpLabel.textContent='MRP';
    compareEl.insertAdjacentElement('beforebegin',mrpLabel);

    offerLabel=document.createElement('span');
    offerLabel.className='pp-price-offer-label';
    offerLabel.textContent='Our price';
    priceEl.insertAdjacentElement('beforebegin',offerLabel);
  }

  const updatePdpSale=()=>{
    const selected=productPage?(productPage.querySelector('[data-pp-variant]:checked')||productPage.querySelector('[data-pp-variant]')):null;
    if(!selected||!badge||!compareEl||!priceEl)return;
    const price=parseMoney(selected.dataset.price);
    const compare=parseMoney(selected.dataset.compare);
    const pct=pctOff(compare,price);
    priceEl.textContent=selected.dataset.price||'';
    if(pct>0){
      compareEl.textContent=selected.dataset.compare||'';
      compareEl.hidden=false;
      badge.textContent=`${pct}% OFF`;
      badge.hidden=false;
      if(mrpLabel)mrpLabel.hidden=false;
    }else{
      compareEl.hidden=true;
      badge.hidden=true;
      if(mrpLabel)mrpLabel.hidden=true;
    }
  };
  updatePdpSale();
  if(productPage)productPage.querySelectorAll('[data-pp-variant]').forEach(input=>input.addEventListener('change',()=>requestAnimationFrame(updatePdpSale)));

  const mainImage=document.querySelector('[data-pp-main-image]');
  if(!mainImage)return;
  mainImage.setAttribute('tabindex','0');mainImage.setAttribute('role','button');mainImage.setAttribute('aria-label','Open product image full screen');
  const overlay=document.createElement('div');overlay.className='pp-image-lightbox';overlay.setAttribute('aria-hidden','true');overlay.innerHTML='<div class="pp-image-lightbox__stage" role="dialog" aria-modal="true" aria-label="Product image"><button type="button" aria-label="Close full-screen image">×</button><img alt=""></div>';document.body.appendChild(overlay);
  const lightboxImage=overlay.querySelector('img');const closeButton=overlay.querySelector('button');let previousFocus=null;
  const open=()=>{previousFocus=document.activeElement;lightboxImage.src=mainImage.currentSrc||mainImage.src;lightboxImage.alt=mainImage.alt||'Product image';overlay.classList.add('is-open');overlay.setAttribute('aria-hidden','false');document.documentElement.classList.add('pp-lightbox-open');closeButton.focus();};
  const close=()=>{overlay.classList.remove('is-open');overlay.setAttribute('aria-hidden','true');document.documentElement.classList.remove('pp-lightbox-open');if(previousFocus&&previousFocus.focus)previousFocus.focus();};
  mainImage.addEventListener('click',open);mainImage.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();open();}});closeButton.addEventListener('click',close);overlay.addEventListener('click',e=>{if(e.target===overlay)close();});document.addEventListener('keydown',e=>{if(e.key==='Escape'&&overlay.classList.contains('is-open'))close();});
});
